<template>
  <el-container>
    <!-- 主体内容 -->
    <el-header style="display: flex; align-items: center; justify-content: space-between">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>工单转办处理</el-breadcrumb-item>
      </el-breadcrumb>
      <el-button-group>
        <el-button type="info" icon="el-icon-position" @click.native="formSubmit(1)" :disabled="data.lastNode.isSucces ||
          (!data.form.transferUnitId && data.form.selectType == 1)
          ">提 交</el-button>
        <el-button type="info" icon="el-icon-eleme" @click.native="browser()">舆情来源</el-button>
        <el-button type="info" icon="el-icon-arrow-left" @click.native="formReturn()">返 回</el-button></el-button-group>
    </el-header>
    <el-main>
      <div>
        <el-tabs type="card" :tab-position="tabPosition" @tab-click="tabclick" v-model="activeTabName">
          <el-tab-pane :key="0" name="tabFirst">
            <span slot="label"><i class="el-icon-date"></i> 工单信息</span>
            <el-form :model="data.pst" status-icon label-width="100px">
              <el-form-item label="录入单位" prop="unitName">
                <el-input v-model="data.pst.unitName" disabled />
              </el-form-item>
              <el-form-item label="录入人" prop="userName">
                <el-input v-model="data.pst.userName" disabled />
              </el-form-item>
              <el-form-item label="舆情类别" prop="pstType">
                <el-input v-model="data.pstTypeName" disabled />
              </el-form-item>
              <el-form-item label="发贴标题" prop="title">
                <el-input v-model="data.pst.title" disabled />
              </el-form-item>
              <el-form-item label="发贴人" prop="name">
                <el-input v-model="data.pst.name" disabled />
              </el-form-item>
              <el-form-item label="发贴时间" prop="postingTime">
                <el-input v-model="data.pst.postingTime" disabled />
              </el-form-item>
              <el-form-item label="来源" prop="pstSource">
                <el-input v-model="data.pst.pstSource" disabled />
              </el-form-item>
              <el-form-item label="贴子内容" prop="pstContent">
                <el-input type="textarea" :rows="10" v-model="data.pst.pstContent" disabled />
              </el-form-item>
              <el-form-item label="状态" prop="statusName">
                <el-input v-model="data.statusName" disabled />
              </el-form-item>
            </el-form>
          </el-tab-pane>
          <!-- 显示节点 -->
          <el-tab-pane :key="node.id" v-for="node in data.nodes" :name="'tab' + node.id">
            <span slot="label"><i :class="pstApi.getStatusIcon(node.status)"></i>
              {{ pstApi.getNodeTitle(node.status) }}</span>
            <el-form :model="node" status-icon label-width="100px">
              <el-form-item label="办理单位" v-if="node.unitName">
                <el-input v-model="node.unitName" disabled />
              </el-form-item>
              <el-form-item label="办理人">
                <el-input v-model="node.userName" disabled />
              </el-form-item>
              <el-form-item label="提交信息" v-if="node.nodeMessage">
                <el-input type="textarea" :rows="2" v-model="node.nodeMessage" disabled />
              </el-form-item>
              <el-form-item label="答复内容" v-if="node.nodeContent">
                <el-input type="textarea" :rows="2" v-model="node.nodeContent" disabled />
              </el-form-item>
              <el-form-item :label="pstApi.getTimeTitle(node.status)" v-if="node.isSucces">
                <el-input :value="node.lastTime
                    ? Common.dateFormatter(node.lastTime, 'yyyy-MM-dd hh:mm')
                    : ''
                  " disabled />
              </el-form-item>
              <el-form-item label="佐证材料" v-if="node.uploadCount > 0">
                <el-card class="box-card">
                  <!-- 文件上传组件 -->
                  <upload :nodeId="node.id" :disabled="true" />
                </el-card>
              </el-form-item>
            </el-form>
          </el-tab-pane>
          <!-- 转办信息 -->
          <el-tab-pane :key="data.nodes.length + 1" name="tabLast">
            <span slot="label"><i class="el-icon-position"></i>
              <font color="green"> 工单转办 </font>
            </span>
            <el-form :model="data.lastNode" ref="pstRef" status-icon label-width="100px">
              <el-form-item label="办理方式">
                <el-radio-group v-model="data.form.selectType">
                  <el-radio :label="1">工单转办</el-radio>
                  <el-radio :label="-1" :disabled="data.pst.pstType == 0 && data.pst.status == 0">{{
                    data.pst.status == 0
                      ? "撤销重审"
                      : data.pst.status == 3
                        ? "撤销重办"
                        : ""
                  }}</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="转办单位" v-if="data.form.selectType == 1">
                <el-select class="tel" v-model="data.form.transferUnitId" placeholder="请选择单位" filterable>
                  <el-option v-for="unit in data.units" :key="unit.id" :label="unit.name" :value="unit.id" />
                </el-select>
              </el-form-item>
              <el-form-item label="转办留言">
                <el-input type="textarea" :rows="3" v-model="data.form.message" :disabled="data.lastNode.isSucces" />
              </el-form-item>
              <el-form-item label="发贴标题" prop="title">
                <el-input v-model="data.pst.title" disabled />
              </el-form-item>
              <el-form-item label="贴子内容" prop="pstContent">
                <el-input type="textarea" :rows="15" v-model="data.pst.pstContent" disabled />
              </el-form-item>
            </el-form>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-main>
  </el-container>
</template>

<script>
import upload from "../../../components/Contents.vue";
export default {
  components: {
    upload,
  },
  created() {
    this.pstApi.setWindowTitle("工单转办处理");
    this.data.pst.id = this.$route.params.id;
    this.data.user = this.pstApi.getUserData();
    this.getUnits(); //读取所有单位信息
    this.getPst(); //读取留言信息
  },
  data() {
    return {
      tabPosition: "right",
      tabIndex: 0,
      activeTabName: "tabLast",
      //数据项
      data: {
        user: "",
        statusName: "",
        pstTypeName: "",
        units: [], //单位数据
        pst: {
          id: "",
        },
        nodes: [],
        //转办数据
        lastNode: {
          id: "",
          isSucces: false,
          lastTime: "",
          nodeContent: "",
          nodeMessage: "",
          pstId: "",
          pstType: 0,
          status: 1,
          transferUnitId: "",
          transferUnitName: "",
          unitId: "",
          unitName: "",
          userId: "",
          userName: "",
          uploadCount: 0,
        },
        // transferNode:"",
        form: {
          selectType: 1,
          transferUnitId: "",
          message: "",
        },
      },
    };
  },
  methods: {
    //查询方法部分
    querySubmit() {
      this.getPst();
    },
    getUnits() {
      this.data.units = [];
      this.userApi.getUnitAll().then((res) => {
        var data = res.data;
        this.data.units = this.data.units.concat(data);
      });
    },
    getPst() {
      this.pstApi
        .getPstInfo(this.data.pst.id)
        .then((res) => {
          var data = res.data;
          //console.log(data);
          this.data.pst = data;
          //
          var transferNodes = data.nodeInfos.filter(
            (node) => node.isSucces == false
          );
          if (transferNodes.length > 0) {
            this.data.lastNode = transferNodes[0];
          }
          this.data.form.selectType = this.data.lastNode.status;
          this.data.form.transferUnitId = this.data.lastNode.transferUnitId;
          this.data.form.message = this.data.lastNode.nodeMessage;
          //
          this.data.lastNode.unitId = this.data.user.unitId;
          this.data.lastNode.unitName = this.data.user.unitName;
          this.data.lastNode.userId = this.data.user.userId;
          this.data.lastNode.userName = this.data.user.name;

          this.data.nodes = data.nodeInfos.filter(
            (node) => node.isSucces == true
          );
          this.data.statusName = this.pstApi.getStatusTransferTitle(
            data.status
          );
          this.data.pstTypeName = this.pstApi.getPstTypeName(data.pstType);
        })
        .catch(() => {
          this.$toast("读取失败");
        });
    },
    formSubmit(buttonType) {
      let pstId = this.data.pst.id;
      let transferUnitId = this.data.form.transferUnitId;
      var message = this.data.form.message;
      let selectType = this.data.form.selectType;
      var submitType = 0;
      if (buttonType == 1) {
        submitType = this.data.form.selectType;
      }

      if (pstId == "" || (transferUnitId == "" && submitType == 1)) {
        this.$toast("请填写转办单位");
        return;
      }
      if (message == "") {
        if (selectType == 1) {
          message = "请办理";
        } else if (selectType == -1 && this.data.pst.status == 0) {
          message = "请重新审核";
        } else if (selectType == -1 && this.data.pst.status == 3) {
          message = "请继续办理";
        }
      }

      this.pstApi
        .newPstTransfer(pstId, transferUnitId, message, submitType)
        .then((res) => {
          if (submitType == 1) {
            this.$toast("提交成功");
            this.formReturn();
          } else if (submitType == 0) {
            this.$toast("保存成功");
            this.getPst();
          } else {
            this.$toast("撤销重审成功");
            this.formReturn();
          }
        })
        .catch((err) => {
          this.$toast(err.response.data.message);
        });
    },
    formReturn() {
      this.$router.back();
    },
    browser() {
      window.open(this.data.pst.pstUrl, "_blank");
    },
    tabclick(tab) {
      this.tabIndex = tab.index;
    },
  },
};
</script>

<style lang="less" scoped>
.el-header {
  background-color: #b3c0d1;
  color: #333;
  line-height: 40px;
}

//工具栏样式
.cust_seach {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 40px;
  width: 100%;
  padding: auto 5px;

  .btnLeft {
    flex: 1;
    margin: 0;

    /deep/ .el-input__inner {
      height: 41px;
      border-radius: 0px;
      border-top-left-radius: 4px;
      border-bottom-left-radius: 4px;
    }
  }

  .btnTitle {
    flex: 2;
    margin: 0;

    /deep/ .el-input__inner {
      height: 41px;
      border-radius: 0px;
      border-top-left-radius: 0px;
      border-bottom-left-radius: 0px;
    }
  }

  .btnStatus {
    flex: 1;
    margin: 0;

    /deep/ .el-input__inner {
      height: 41px;
      border-radius: 0px;
      border-top-right-radius: 0px;
      border-bottom-right-radius: 0px;
    }
  }

  .el-button-group>.el-button:first-child:last-child {
    border-radius: 0px;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
  }
}

.el-select {
  float: left;
}

.cust_pagin {
  display: flex;
  position: sticky;
  bottom: 0;
  z-index: 999;
}

/deep/.el-breadcrumb__separator {
  color: rgb(87, 86, 86);
}

/deep/.el-textarea.is-disabled .el-textarea__inner {
  background-color: #fff;
  border-color: #e4e7ed;
  color: #031944;
  cursor: auto;
}

/deep/.el-input.is-disabled .el-input__inner {
  background-color: #fff;
  border-color: #e4e7ed;
  color: #031944;
  cursor: auto;
}
</style>